import { createSlice } from "@reduxjs/toolkit";

export const selectPickGameGameInfo = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_GAME_INFO;
export const selectPickGameTimer = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_GAME_TIMER_START;
export const selectPickNextDealTime = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_NEXT_DEAL_TIME;
export const selectPickTrNo = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.LAST_TR_NO;
export const selectPickCurrentDrawTime = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_CURRENT_DRAW_TIME;
export const selectPickLastWinCards = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_LAST_WIN_CARDS;
export const selectPickThreeBet = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_THREE_BET;
export const selectPickWalletAmount = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_WALLET_AMOUNT;
export const selectPickReport = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_REPORT;
export const selectPickBetList = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_GET_BET_LISTS;
export const selectAllTimeSlot3d = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.TIME_SLOT_ALL;
export const selectPickPrintTicket3d = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PrintTicketData3d;
export const selectPickLastSaleAmount = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.Pick_Last_Sale_Amount;
export const selectPickResultDates = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_Result_Dates;
export const selectPickResultTime = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_Result_time;
export const selectAnnouncement = ({ gameInfo3dSlice }) =>
  gameInfo3dSlice.PICK_Announcement;
export const SelectClaimTicket3d = ({ gameInfo3dSlice }) => gameInfo3dSlice.claim_ticket_id
export const SelectClaimTicketRecord3d = ({ gameInfo3dSlice }) => gameInfo3dSlice.claim_ticket_record
export const SelectWinLoseRecord3d = ({ gameInfo3dSlice }) => gameInfo3dSlice.win_lose

const gameInfo3dSlice = createSlice({
  name: "gameInfo3dSlice",
  initialState: {
    PICK_GAME_INFO: null,
    PICK_GAME_TIMER_START: 0,
    PICK_NEXT_DEAL_TIME: null,
    TIME_SLOT_ALL: [],
    LAST_TR_NO: null,
    PICK_CURRENT_DRAW_TIME: null,
    PICK_LAST_WIN_CARDS: [],
    PICK_THREE_BET: null,
    PICK_WALLET_AMOUNT: 0,
    PICK_REPORT: [],
    PICK_GET_BET_LISTS: [],
    PrintTicketData3d: null,
    Pick_Last_Sale_Amount: 0,
    PICK_Result_Dates: [],
    PICK_Result_time: {},
    PICK_Announcement: "",
    claim_ticket_id: '',
    claim_ticket_record: {},
         win_lose: {}
  },
  reducers: {
    setPickGameData: (state, action) => {
      state.PICK_GAME_INFO = { ...action.payload };
    },
    setPickGameTimer: (state, action) => {
      state.PICK_GAME_TIMER_START = action.payload;
    },
    setPcikNextDelalTime: (state, action) => {
      state.PICK_NEXT_DEAL_TIME = action.payload;
    },
    setPickLastTrNo: (state, action) => {
      state.LAST_TR_NO = action.payload;
    },
    setPickkCurrentDrawTime: (state, action) => {
      state.PICK_CURRENT_DRAW_TIME = action.payload;
    },
    setPickLastWinCards: (state, action) => {
      state.PICK_LAST_WIN_CARDS = [...action.payload].reverse();
    },
    setLotteryPlaceBet3d: (state, action) => {
      state.PICK_THREE_BET = action.payload;
    },
    setWalletAmount3d: (state, action) => {
      state.PICK_WALLET_AMOUNT = action.payload;
    },
    setLotteryReport3d: (state, action) => {
      state.PICK_REPORT = [...action.payload];
    },
    setLotteryBetList3d: (state, action) => {
      state.PICK_GET_BET_LISTS = [...action.payload];
    },
    setPrintTicketData3d: (state, action) => {
      state.PrintTicketData3d = action.payload;
    },
    setTimeSlotData3d: (state, action) => {
      state.TIME_SLOT_ALL = [...action.payload];
    },
    setLastSaleAmount3d: (state, action) => {
      state.Pick_Last_Sale_Amount = action.payload;
    },
    setResultDates3d: (state, action) => {
      state.PICK_Result_Dates = [...action.payload];
    },
    ResultTimeSet3d: (state, action) => {
      state.PICK_Result_time = { ...action.payload };
    },
    setPICK_Announcement: (state, action) => {
      state.PICK_Announcement = action.payload;
    },
    SET_CLAIM_TICKET_ID_3D: (state, { payload }) => { state.claim_ticket_id = payload },
    SET_CLAIM_TICKET_RECORD_3D: (state, { payload }) => { state.claim_ticket_record = { ...payload } },
    SET_WIN_LOSE_RECORD_3D: (state, { payload }) => { state.win_lose = payload  },
    clearWinLoseRecord3d: (state) => {
      state.win_lose = {};
    }
  },
});

export const {
  setPickGameData,
  setPickGameTimer,
  setPcikNextDelalTime,
  setPickLastTrNo,
  setPickkCurrentDrawTime,
  setPickLastWinCards,
  setLotteryPlaceBet3d,
  setWalletAmount3d,
  setLotteryReport3d,
  setLotteryBetList3d,
  setPrintTicketData3d,
  setLastSaleAmount3d,
  setResultDates3d,
  ResultTimeSet3d,
  setTimeSlotData3d,
  setPICK_Announcement,
  SET_CLAIM_TICKET_ID_3D,
  SET_CLAIM_TICKET_RECORD_3D,
  SET_WIN_LOSE_RECORD_3D,
  clearWinLoseRecord3d
} = gameInfo3dSlice.actions;

export default gameInfo3dSlice.reducer;